<div class="db-add-domain-list-dialog">
  <div class="db-nameServers-block">
    <div class="ds-notification-black mb20" *ngIf="!isDomainPointed && fromDetails">
      <div>
        <img src="assets/images/icons/close_error_icon-red.svg" />
        <p><span [innerHTML]="'text_domainNotPointedNotTenWebDomainNotice' | dbText "></span></p>
      </div>
    </div>

    <h3 class="mb8" [ngClass]="{'db-subdomain': subdomainCase}">{{(fromDetails ? 'text_domainNotPointedIsTenWebDomain' : 'text_domainAddedToYourSiteHeader') | dbText }}</h3>
    <p class="mb30">{{(fromDetails ? 'text_domainNotPointedNotTenWebDomainDesc' : 'text_customDomainAddedToYourSiteDesc' )| dbText }}</p>
    <div class="db-nameservers-block">

      <div class="db-nameservers-block-item" *ngFor="let nameserver of (nameServers ? nameServers : defaultNameservers); let i = index">
        <div class="db-nameservers-block-item-label">{{ 'text_addDomain.nameserver.label' | dbText: {number: i + 1} }}
        </div>
        <div class="db-nameservers-block-item-text-wrap" ngxClipboard [cbContent]="nameserver" (cbOnSuccess)="copied(i)"
             dsTooltipSize="small" dsTooltipPosition="top"
             dsTooltipAlign="right"
             dsTooltipColor="white"
             [hostClass]="'cover-all'"
             [dsTooltip]="'<b>' + ((isCopied[i] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
          <span class="dot"></span>
          <span>{{ nameserver }}</span>
          <i class="db-icon db-icon-ds-copy"></i>
        </div>
      </div>
    </div>
  </div>


  <div class="db-dns-block">
    <div class="db-copy-info db-with-border mb50">
      <p class="mb20" [innerHTML]="'text_domainNotPointedNotTenWebDomainInfo' | dbText"></p>
      <div class="db-copy-info__list-header">
          <p>{{ 'text_type' | dbText }}</p>
          <p>{{ 'text_name' | dbText }}</p>
          <p>{{ 'text_value' | dbText }}</p>
      </div>
      <ul>
        <li class="db-copy-info__list-item">
          <p>A</p>
          <div  ngxClipboard [cbContent]="domainName" (cbOnSuccess)="copied(0)"
                dsTooltipSize="small" dsTooltipPosition="top"
                [hostClass]="'cover-all'"
                dsTooltipColor="black"
                [dsTooltip]="'<b>' + ((isCopied[0] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
            <div class="form-control host-name" #inputHostNameA>{{domainName}}</div>
            <i class="db-icon db-icon-ds-copy"></i>
          </div>

          <div  ngxClipboard [cbContent]="ipv4Address" (cbOnSuccess)="copied(1)"
                dsTooltipSize="small" dsTooltipPosition="top"
                dsTooltipAlign="right"
                dsTooltipColor="black"
                [hostClass]="'cover-all'"
                [dsTooltip]="'<b>' + ((isCopied[1] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
            <div class="form-control host-name">{{ipv4Address}}</div>
            <i class="db-icon db-icon-ds-copy">
            </i></div>

        </li>
        <li class="db-copy-info__list-item">
          <p>CNAME</p>

          <div ngxClipboard  [cbContent]="'www.' + domainName" (cbOnSuccess)="copied(2)"
               dsTooltipSize="small" dsTooltipPosition="top"
               dsTooltipAlign="right"
               dsTooltipColor="black"
               [hostClass]="'cover-all'"
               [dsTooltip]="'<b>' + ((isCopied[2] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
            <div class="form-control host-name" >{{'www.' + domainName}}</div>
            <i class="db-icon db-icon-ds-copy"></i>
          </div>

          <div ngxClipboard  [cbContent]="domainName" (cbOnSuccess)="copied(3)"
               dsTooltipSize="small" dsTooltipPosition="top"
               dsTooltipAlign="right"
               dsTooltipColor="black"
               [hostClass]="'cover-all'"
               [dsTooltip]="'<b>' + ((isCopied[3] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
            <div class="form-control host-name">{{domainName}}</div>
            <i class="db-icon db-icon-ds-copy"></i>
          </div>

        </li>
      </ul>
    </div>

    <div class="db-add-domain-list-dialog__footer">
      <button class="ds-btn-black" (click)="closeModal()">
        <span>{{ 'text_gotIt' | dbText }}</span>
      </button>
    </div>
  </div>
  <db-loading-screen *ngIf="nsLoading" [ngClass]="{'hidden':!nsLoading && !fromDetails}" [pageBlocker]="true"></db-loading-screen>
</div>
